import {FC} from "react";
import {Button} from "@mui/material";
import {
    useLocation,
    useNavigate,
} from "react-router-dom";
import {Locale} from "../locales/Locale";
import {IdlocaGeneric} from "../locales/IdlocaGeneric";
import {useTheme} from "@mui/material/styles";

interface IMenuItem {
    localeId: IdlocaGeneric;
    redirectUrl: string;
}

export const MenuItem: FC<IMenuItem> = ({localeId, redirectUrl}) => {
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();

    const isActive = location.pathname === redirectUrl;

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        e.preventDefault();
        navigate(redirectUrl);
    };

    return (
        <a
            href={redirectUrl}
            onClick={handleClick}
            style={{textDecoration: "none", color: "inherit"}}
        >
            <Button
                sx={{
                    fontWeight: 500,
                    textTransform: "uppercase",
                    color: isActive
                        ? theme.palette.menuActive.text
                        : theme.palette.menuInactive.text,
                    backgroundColor: isActive
                        ? theme.palette.menuActive.main
                        : theme.palette.menuInactive.main,
                    "&:hover": {
                        backgroundColor: theme.palette.menuActive.main,
                        color: theme.palette.menuActive.text,
                    },
                }}
            >
                <Locale localeId={localeId}/>
            </Button>
        </a>
    );
};
